import styled from 'styled-components';

import { CommonTheme } from 'app/shared/theme';
import {
  withCursorCSS,
  WithCursorProps,
} from 'app/shared/components/styleUtils/withCursorCSS';
import {
  withDimensionsCSS,
  WithDimensionsProps,
} from 'app/shared/components/styleUtils/withDimensionsCSS';
import {
  withFontCSS,
  WithFontProps,
} from 'app/shared/components/styleUtils/withFontCSS';
import {
  withInputStyleCSS,
  WithInputStyleProps,
} from 'app/shared/components/styleUtils/withInputStyleCSS';
import {
  withSpacingCSS,
  WithSpacingProps,
} from 'app/shared/components/styleUtils/withSpacingCSS';

export interface TextareaProps
  extends React.ComponentPropsWithRef<'textarea'>,
    WithInputStyleProps,
    WithSpacingProps,
    WithCursorProps,
    WithFontProps,
    WithDimensionsProps {}

interface TextareaCSSProps extends TextareaProps {
  theme: CommonTheme;
}

export const Textarea = styled.textarea<TextareaCSSProps>`
  ${withCursorCSS};
  ${withInputStyleCSS};
  ${withSpacingCSS};
  ${withFontCSS};
  ${withDimensionsCSS};
`;
